import {
  DoBootstrap,
  Injector,
  NgModule,
} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';

// Components
import { FormioModule, FormioComponent, FormioAppConfig } from '@formio/angular';

@NgModule({
  imports: [
    BrowserModule,
    FormioModule,
  ],
  providers: [
    {
      // FormioBaseComponent.getRendererOptions() already defaults to
      // `icons: 'fontawesome'`, which is what makes components emit
      // `<i class="fa fa-*">`. Pinned explicitly so the pairing with the Font
      // Awesome import in styles.scss is discoverable, and so a change to that
      // upstream default cannot silently break icon rendering.
      provide: FormioAppConfig,
      useValue: { icons: 'fontawesome' },
    },
  ],
  schemas: [],
})
export class MncFormIOModule implements DoBootstrap {
  constructor(
    private injector: Injector,
  ) {
    this.registerCustomElement('mnc-formio', FormioComponent);
  }

  ngDoBootstrap(): void {
    return;
  }

  private registerCustomElement(name: string, component: any) {
    if (customElements.get(name)) return;
    customElements.define(name, createCustomElement<any>(component, { injector: this.injector }));
  }
}
